import { blake3 } from '@noble/hashes/blake3';
/**
 * Returns a digest of the given data using the Blake3 algorithm.
 */
export function hash(data, bytes = 32) {
    return blake3(data, { dkLen: bytes });
}
/**
 * Returns a keyed hash of the given data using the Blake3 algorithm. The key
 * must be 32 bytes.
 */
export function keyedHash(data, key, bytes = 64) {
    // todo - workaround for this bug: https://github.com/paulmillr/noble-hashes/issues/50
    const keyCopy = typeof key === 'string' ? key : new Uint8Array(key);
    return blake3(data, { dkLen: bytes, key: keyCopy });
}
/**
 * Derives a 32 byte key from the given key material and context string.
 */
export function deriveKey(data, ctx) {
    return blake3(data, { dkLen: 32, context: ctx });
}
